import Link from "next/link";
import Image from "next/image";
import { useState } from "react";
import CuratorWidget from "../../CuratorWidget";
import TiktokIcon from "../../../../public/images/icons/tiktok.svg";
import styles from "../../../styles/multimedia/Multimedia.module.scss";

const Tiktok = () => {
  const channels = {
    marcosImbento: "Marcos Imbento, Bistado",
    hindiItoMarites: "Hindi Ito Marites",
    factChecks: "Fact Checks",
    reportersReels: "Reporters' Reels",
  };

  const [currentChannel, setCurrentChannel] = useState(channels.marcosImbento);

  const loader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  const RenderTIktokFeeds = () => {
    switch (currentChannel) {
      case channels.marcosImbento:
        return (
          <div>
            <div className={styles.channelsDescription}>
              <h2 className={styles.channelTitle}>{channels.marcosImbento}</h2>
              <div className={styles.descriptionWrapper}>
                <p className={styles.description}>
                  Ang Marcos Imbento, Bistado ay isang Rappler series kung saan
                  titibagin ang mga kasinungalingan at kathang-isip na bumabalot
                  sa pamilyang Marcos at sa Martial Law. Bawat linggo ay may
                  maikling Tiktok video kung saan tinatalakay ni Rappler
                  multimedia reporter Rambo Talabong, batay sa research ni
                  Jodesz Gavilan, ang mga datos at iba pang impormasyong
                  nagtatama at naglilinaw sa mga kumakalat na kasinungalingan.
                </p>
                <div className={styles.iconContainer}>
                  <h6 className={styles.smallHeadline}>Watch us on</h6>
                  <div className={styles.iconWrapper}>
                    <div className={styles.channelIcon}>
                      <Link href="https://www.tiktok.com/@rappler" passHref>
                        <a target="_blank">
                          <Image
                            loader={loader}
                            src={TiktokIcon}
                            alt="Youtube"
                            layout="responsive"
                          />
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CuratorWidget feedId="2228432a-9854-4251-8491-5f57abf9a9c3" />
          </div>
        );
      case channels.hindiItoMarites:
        return (
          <div>
            <div>
              <div className={styles.channelsDescription}>
                <h2 className={styles.channelTitle}>
                  {channels.hindiItoMarites}
                </h2>
                <div className={styles.descriptionWrapper}>
                  <p className={styles.description}>
                    Sa seryeng Hindi Ito Marites, magbabahagi si Rappler
                    editor-at-large Marites Vitug ng trivia mula sa kanyang
                    interviews, newsletter na Sui Generis, at iba pang verified
                    information tungkol sa maiinit na isyu ng bayan.
                  </p>
                  <div className={styles.iconContainer}>
                    <h6 className={styles.smallHeadline}>Follow us on</h6>
                    <div className={styles.iconWrapper}>
                      <div className={styles.channelIcon}>
                        <Link href="https://www.tiktok.com/@rappler" passHref>
                          <a target="_blank">
                            <Image
                              loader={loader}
                              src={TiktokIcon}
                              alt="Youtube"
                              layout="responsive"
                            />
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CuratorWidget feedId="215f8ec5-db81-442d-b4b5-4ff731ae88fe" />
            </div>
          </div>
        );
      case channels.factChecks:
        return (
          <div>
            <div>
              <div className={styles.channelsDescription}>
                <h2 className={styles.channelTitle}>{channels.factChecks}</h2>
                <div className={styles.descriptionWrapper}>
                  <p className={styles.description}>
                    The 2022 election is more politically and emotionally
                    charged than ever. These quick fact check videos on TikTok
                    help filter the noise, and make facts spread faster and
                    further than hate and lies.
                  </p>
                  <div className={styles.iconContainer}>
                    <h6 className={styles.smallHeadline}>Follow us on</h6>
                    <div className={styles.iconWrapper}>
                      <div className={styles.channelIcon}>
                        <Link href="https://www.tiktok.com/@rappler" passHref>
                          <a target="_blank">
                            <Image
                              loader={loader}
                              src={TiktokIcon}
                              alt="Youtube"
                              layout="responsive"
                            />
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CuratorWidget feedId="49c0a136-d888-4a3f-9c87-77787fd3138b" />
            </div>
          </div>
        );
      case channels.reportersReels:
        return (
          <div>
            <div>
              <div className={styles.channelsDescription}>
                <h2 className={styles.channelTitle}>
                  {channels.reportersReels}
                </h2>
                <div className={styles.descriptionWrapper}>
                  <p className={styles.description}>
                    Rappler reporters unpack today&apos;s most pressing issues
                    on TikTok.
                  </p>
                  <div className={styles.iconContainer}>
                    <h6 className={styles.smallHeadline}>Follow us on</h6>
                    <div className={styles.iconWrapper}>
                      <div className={styles.channelIcon}>
                        <Link href="https://www.tiktok.com/@rappler" passHref>
                          <a target="_blank">
                            <Image
                              loader={loader}
                              src={TiktokIcon}
                              alt="Youtube"
                              layout="responsive"
                            />
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CuratorWidget feedId="f37344a0-221b-405e-bf02-59b96e2e53a8" />
            </div>
          </div>
        );
    }
  };

  const activeChannel = (selectedChannel) =>
    currentChannel === selectedChannel ? styles.active : "";

  return (
    <section className={`${styles.multimediaWrapper} ${styles.tiktok}`}>
      <h2 className={styles.sectionTitle}>Tiktok</h2>

      <div className={styles.channelTabs}>
        <button
          className={activeChannel(channels.marcosImbento)}
          onClick={() => {
            setCurrentChannel(channels.marcosImbento);
          }}
        >
          {channels.marcosImbento}
        </button>
        <button
          className={activeChannel(channels.hindiItoMarites)}
          onClick={() => setCurrentChannel(channels.hindiItoMarites)}
        >
          {channels.hindiItoMarites}
        </button>
        <button
          className={activeChannel(channels.factChecks)}
          onClick={() => setCurrentChannel(channels.factChecks)}
        >
          {channels.factChecks}
        </button>
        <button
          className={activeChannel(channels.reportersReels)}
          onClick={() => setCurrentChannel(channels.reportersReels)}
        >
          {channels.reportersReels}
        </button>
      </div>

      {RenderTIktokFeeds()}
    </section>
  );
};

export default Tiktok;
